export default {
  'notes.panel.add': '+ Add Note',
  'notes.panel.isEmpty': 'No notes have been created yet.',
  'notes.panel.isLoading': 'Loading...',
  'notes.note.cancel': 'Cancel',
  'notes.note.remove': 'Remove',
  'notes.note.edit': 'Edit',
  'notes.note.save': 'Save',
  'notes.note.details.name': '{firstName} {lastName}',
  'notes.note.details.timestamp': '- {time}',
  'notes.note.editor.label': 'Enter a note:',
  'notes.note.not-saved': 'This note has not been saved!',
};
